/* Moins "splash" pri dodavanju u korpu: konfeti iz dugmeta + poskakivanje ikone korpe. */
(() => {
  if (window.__moinsSplash) return;
  window.__moinsSplash = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const COLORS = ['#4f5d49', '#6b7a63', '#b58f5e', '#b9573f', '#ecdcd0'];
  const style = document.createElement('style');
  style.textContent = `
    .m-splash{position:fixed;left:0;top:0;width:14px;height:14px;border-radius:3px;pointer-events:none;z-index:2147483647;will-change:transform,opacity}
    @keyframes m-bump{0%{transform:scale(1)}30%{transform:scale(1.35) rotate(-8deg)}60%{transform:scale(.92) rotate(5deg)}100%{transform:scale(1)}}
    .m-bump{animation:m-bump .6s ease}
  `;
  document.head.appendChild(style);

  const burst = (el) => {
    const r = el.getBoundingClientRect();
    const cx = r.left + r.width / 2;
    const cy = r.top + r.height / 2;
    for (let i = 0; i < 90; i++) {
      const p = document.createElement('i');
      p.className = 'm-splash';
      p.style.background = COLORS[i % COLORS.length];
      if (i % 3 === 0) p.style.borderRadius = '50%';
      if (i % 4 === 0) { p.style.width = '20px'; p.style.height = '20px'; }
      document.body.appendChild(p);
      const angle = (Math.PI * 2 * i) / 90 + Math.random() * 0.4;
      const dist = 70 + Math.random() * 110;
      const dx = Math.cos(angle) * dist;
      const dy = Math.sin(angle) * dist - 50;
      p.animate(
        [
          { transform: `translate(${cx}px, ${cy}px) scale(1) rotate(0deg)`, opacity: 1 },
          { transform: `translate(${cx + dx}px, ${cy + dy}px) scale(1) rotate(${Math.random() * 360}deg)`, opacity: 1, offset: 0.6 },
          { transform: `translate(${cx + dx}px, ${cy + dy + 70}px) scale(.4) rotate(${Math.random() * 540}deg)`, opacity: 0 },
        ],
        { duration: 1500 + Math.random() * 500, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' }
      ).onfinish = () => p.remove();
    }
  };

  const bump = () => {
    const icon = document.querySelector('.header-actions__cart-icon');
    if (!icon) return;
    icon.classList.remove('m-bump');
    void icon.offsetWidth;
    icon.classList.add('m-bump');
    setTimeout(() => icon.classList.remove('m-bump'), 700);
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('add-to-cart-component button[type="submit"], .m-dup__btn');
    if (!btn || btn.disabled || btn.closest('[data-buy-now]')) return;
    burst(btn);
    setTimeout(bump, 600);
  }, true);
})();
